
type AppSettings = {
    api: {
        portalApi: string,
        webSite: string,
    },
    identityServer: string,
    userAdminLink: string,
    environmentIndicator: string,
    installAppLink?: string
}




const mobileDev: AppSettings = {
    api: {
        portalApi: "https://it-bhp-rail-portal-api-pov.azurewebsites.net",
        webSite: "https://it-bhp-rail-portal-web-pov.azurewebsites.net",
    },
    identityServer: "https://it-bhp-rail-identityserver-web-pov.azurewebsites.net",
    userAdminLink: "https://it-bhp-rail-identityserver-web-pov.azurewebsites.net/Identity/admin/",
    environmentIndicator: " (DEV)"
};


const dev: AppSettings = {
    api: {
        portalApi: "https://localhost:44326",
        webSite: "https://localhost:44355",
    },
    identityServer: "https://localhost:5001",
    userAdminLink: "https://localhost:5001/Identity/admin/",
    environmentIndicator: " (DEV)",
    installAppLink: "/app/"
};

const povenv: AppSettings = {
    api: {
        portalApi: "https://it-bhp-rail-portal-api-pov.azurewebsites.net",
        webSite: "https://it-bhp-rail-portal-web-pov.azurewebsites.net",
    },
    identityServer: "https://it-bhp-rail-identityserver-web-pov.azurewebsites.net",
    userAdminLink: "https://it-bhp-rail-identityserver-web-pov.azurewebsites.net/Identity/admin/",
    environmentIndicator: " (DEV)",
    installAppLink: "/app/"
};

const sitenv: AppSettings = {
    api: {
        portalApi: "https://rail-portal-api-sit.bhp.com",
        webSite: "https://rail-test.bhp.com",
    },
    identityServer: "https://rail-identityserver-web-sit.bhp.com",
    userAdminLink: "https://rail-identityserver-web-sit.bhp.com/Identity/admin/",
    environmentIndicator: " (TEST)",
    installAppLink: "/app/"
};

const npenv: AppSettings = {
    api: {
        portalApi: "https://rail-portal-api-np.bhp.com",
        webSite: "https://rail-qa.bhp.com",
    },
    identityServer: "https://rail-identityserver-web-np.bhp.com",
    userAdminLink: "https://rail-identityserver-web-np.bhp.com/Identity/admin/",
    environmentIndicator: " (QA)",
    installAppLink: "/app/"
};

const prodenv: AppSettings = {
    api: {
        portalApi: "https://rail-portal-api.bhp.com",
        webSite: "https://rail.bhp.com",
    },
    identityServer: "https://rail-identityserver-web.bhp.com",
    userAdminLink: "https://rail-identityserver-web.bhp.com/Identity/admin/",
    environmentIndicator: "",
    installAppLink: "/app/"
};

// Reference the API location based upon an environment variable.  This variable should be set up deployment of the app service

let appSettings = dev;
let env = process.env.REACT_APP_Env || process.env.NODE_ENV;



if (env === "development") appSettings = mobileDev;
if (env === "webdevelopment") appSettings = dev;
if (env === "povenv") appSettings = povenv;
if (env === "sitenv") appSettings = sitenv;
if (env === "npenv") appSettings = npenv;
if (env === "prodenv") appSettings = prodenv;


// TODO change back when released to production.  This is for mobile app as haven't been able to get set the environment manually
if (env === "production") appSettings = npenv;

export const getPortalApi = (apiPath: string) => `${appSettings.api.portalApi}${apiPath}`;

export default appSettings;